import type { Newsletter } from "~types/types";

type NewsletterApiRequest = {
    slug: string;
};

export async function fetchNewsletterFromApi({ slug }: NewsletterApiRequest) {
    const newsletterResponse = await fetch(
        `/lineup-next/api/newsletter/${slug}`
    );

    if (!newsletterResponse.ok) {
        throw new Error(
            `Error when fetching from api/newsletter: ${await newsletterResponse.text()}`
        );
    }

    return (await newsletterResponse.json()) as Newsletter;
}
